import { useEffect } from 'react';
import '../css/bg.css';
import Header from '../Components/Header/header';
import { checkTokenAndNavigate } from "../Utils/checkNavigate";
import { refreshToken } from '../Context/RefreshToken';
import { useNavigate } from "react-router-dom";
import IntakeFormPdf from "../Components/Assets/intake.pdf";
import SurgicalPdf from "../Components/Assets/surgical.pdf";
import Consent from "../Components/Assets/consent.pdf";
import usePinLock from '../Utils/pinLock';

const Help = () => {
    const navigate = useNavigate();

    useEffect(() => {
        checkTokenAndNavigate(navigate)
    }, [navigate]);

    const tryRefresh = async (autoReloadBool) => {
        await refreshToken({
            navigate,
            onSuccess: (token) => console.log("Refreshed:", token),
            onError: (err) => console.error("Failed to refresh", err),
            autoReload: autoReloadBool
        });
    };

    const { isLocked } = usePinLock(tryRefresh);


    const practice = localStorage.getItem("digital-form-dept-practice");
    const isRSI = practice === 'rsi';

    return (
        <div id="file-queue" className={`min-h-screen flex flex-col ${isLocked ? "blur-2xl" : ""}`}>
            <Header pageTitle="User Manual" />
            <div className="flex flex-col flex-grow bg-white shadow-inner rounded-none p-6 w-full h-full">
                <div style={{ display: "flex", gap: 20, height: "80vh" }}>
                    <iframe
                        src={IntakeFormPdf}
                        title="Intake Form"
                        width="50%"
                        height="100%"
                        style={{ border: "1px solid #ccc" }}
                    />
                    {isRSI ? (
                        <iframe
                            src={SurgicalPdf}
                            title="Surgical Form"
                            width="50%"
                            height="100%"
                            style={{ border: "1px solid #ccc" }}
                        />
                    ) : (
                        <iframe
                            src={Consent}
                            title="Consent Intake Form"
                            width="50%"
                            height="100%"
                            style={{ border: "1px solid #ccc" }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Help;
